<template>
  <el-card>
    <bean-list
      :columns="columns"
      :value="data"
      size="mini"
    />
  </el-card>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class CommercialDocument extends Vue {
  @Prop({ type: Object, default: () => ({}) }) data;

  get profileColumns() {
    return [
      {
        prop: 'avatar',
        label: this.$t('plutus_entries.avatar'),
        renderCell: 'storageAttachment'
      },
      {
        prop: 'first_name',
        label: this.$t('plutus_entries.first_name'),
      },
      {
        prop: 'last_name',
        label: this.$t('plutus_entries.last_name'),
      },
      {
        prop: 'whatsapp',
        label: this.$t('plutus_entries.whatsapp'),
      },
    ]
  }

  get walletHolderColumns() {
    return [
      {
        prop: 'user_id',
        label: 'ID',
        renderCell: (h, { props: { scope: { row } } }) => {
          if (row) {
            return <div>
              {row.user_id ? <span>{ `${row.user_id} (${this.$t('model.user')} ID)` }</span> : ''}
              {row.agent_id ? <span>{ `${row.agent_id} (${this.$t('model.agent')} ID)` }</span> : ''}
              { !row.user_id && !row.agent_id ? '/' : ''}
            </div>;
          }
        }
      },
      {
        prop: 'phone',
        label: this.$t('plutus_entries.phone'),
        renderCell: (h, { props: { value, scope: { row } } }) => {
          if (row) {
            const { user_id, agent_id } = row;
            return (<div>
                { user_id ? <bean-link KeepNode to={{ name: 'users.show', params: { id: user_id } }}>{value}</bean-link> : '' }
                { agent_id ? <bean-link KeepNode to={{ name: 'agents.show', params: { id: agent_id } }}>{value}</bean-link> : '' }
              </div>);
          }
        }
      },
      {
        prop: 'profile_attributes',
        label: this.$t('plutus_entries.profile_attributes'),
        renderCell: (h, { props: { value } }) => {
          return <bean-list value={value} columns={this.profileColumns} />
        }
      }
    ]
  }

  get columns() {
    return [
      {
        prop: 'id',
        label: this.$t('plutus_entries.commercial_document_id'),
      },
      {
        prop: 'creditor_number',
        label: this.$t('plutus_entries.creditor_number'),
      },
      {
        prop: 'creditor_miapay_wallet_holder',
        label: this.$t('plutus_entries.creditor_miapay_wallet_holder'),
        renderCell: (h, { props: { value } }) => {
          if (value.user_id || value.agent_id) {
            return (
              <el-card shadow="never">
                <bean-list columns={this.walletHolderColumns} value={value} />
              </el-card>
            )
          } else {
            return <span>/</span>
          }
        }
      },
      {
        prop: 'debitor_number',
        label: this.$t('plutus_entries.debitor_number'),
      },
      {
        prop: 'debitor_miapay_wallet_holder',
        label: this.$t('plutus_entries.debitor_miapay_wallet_holder'),
        renderCell: (h, { props: { value } }) => {
          if (value.user_id || value.agent_id) {
            return (
              <el-card shadow="never">
                <bean-list columns={this.walletHolderColumns} value={value} />
              </el-card>
            )
          } else {
            return <span>/</span>
          }
        }
      }
    ];
  }
}
</script>
